<template>
<div>
	 <b-toast
		id="toast-check-modal-confirm-request-private"
		variant="none"
		no-close-button
		toaster="b-toaster-top-center"
		>
		<img
			src="@/assets/img/ico-check.png"
			style="margin-right: 10px; margin-top: -2px"
		/>
		{{ message }}
		</b-toast>
		<b-toast
		id="toast-equis-modal-confirm-request-private"
		variant="none"
		no-close-button
		toaster="b-toaster-top-center"
		>
		<img
			src="@/assets/img/ico-equis.png"
			style="margin-right: 10px; margin-top: -2px"
		/>
		{{ message }}
		</b-toast>
		 <b-modal id="modal-confirm-private" :title="$t('title.2')"  :centered="true">
			 	  <template #modal-header="{ close }">
        <img class="close" src="@/assets/img/close_red.png" @click="close()">
          <h5 style="text-align: center;">{{$t('modals.modalConfirmPrivate.titulo')}}  {{dataTeacher}}?</h5>
      </template>
		 
    <template #modal-footer>
      	<b-button variant="danger" @click="$bvModal.hide('modal-confirm-private')"> {{$t('modals.modalConfirmPrivate.button')}} </b-button>
		<b-button @click="confirmCancelRequest" variant="primary" :class="{ loading: showSpinnerSave }">{{$t('modals.modalConfirmPrivate.text')}}</b-button>
    </template>
	</b-modal>
</div>
   
</template>
<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import { convertTimeToUTC, convertTimeCalendarEvents } from '@/assets/js/util.js';



export default {
	name:"modalConfirmPrivate",
	data() {
		return {
			showSpinnerSave:false,
			message: '',
			dataTeacher : '',
            data : {}
		}
	},
	created() {
	
	},
	methods: {
		confirmCancelRequest(){
			this.showSpinnerSave = true;

			convertTimeCalendarEvents(this.data.ScheduleDetail, this.$store.state.user.timeZoneName, this.$moment);
			 
			
            baseInstanceAxios
            .post(`${this.apiURL}/resources/GroupsCoursesLessons/SaveScheduleRequest`,this.data)
            
			.then(response => {
                this.showSpinnerSave = false;
				this.message = this.$t('modals.modalConfirmPrivate.message-success')
				this.$bvToast.show("toast-check-modal-confirm-request-private");
				this.$bvModal.hide('modal-confirm-private');
                this.$emit('updateSchedulePrivate')
            })
            .catch(err =>{
                this.showSpinnerSave = false;
                this.message = this.$t('modals.modalConfirmPrivate.message-error')
                this.$bvToast.show("toast-equis-modal-confirm-request-private");
                console.log("err : ",err)
            }) 
		},
		showModal(teacher,dataSend){
			this.dataTeacher = teacher
            this.data = dataSend
			console.log("this.data: ",this.data)
			this.$bvModal.show("modal-confirm-private")
		}
	}

}
</script>